import React from 'react';
import AppContextClass from './AppContextClass';

export const AppContext = React.createContext(new AppContextClass());